 /* globals urls, RSVP, initCourseEventHandlers */

// TODO: Update this class to use the new loader class to implement the mega loader pattern
var $ = jQuery.noConflict();
window.CourseDetails = function(intCourseTemplateId){
	this.RSVP = RSVP;
	this.validSections = ['notes', 'past', 'current', 'future', 'all'];
	this.sectionMappings = {
		notes: {id: 'course-details-notes-contain'},
		past: {id: 'course-details-past-contain'},
		current: {id: 'course-details-current-contain'},
		future: {id: 'course-details-future-contain'}
	};
	this.templateId = intCourseTemplateId;
};

// Takes an array of course details section names
CourseDetails.prototype.requestSections = function(sections){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		if( !self.isSectionsArrayValid( sections ) ){
			reject( 'Unsupported course details section(s) specified' );
		}
		
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'fetch_course_details_sections',
				templateId: self.templateId,
				sections: sections.join(',')
			}
		})
		.done(function( res ) {
			if( res ){
				resolve( res );
			}
			reject( 'An error occurred while fetching course details' );
		});
	});
};

// Takes an integer as course instance id
CourseDetails.prototype.requestInstanceDetails = function(instanceId){
	 var self = this;
	//console.log('fetch_course_instance_details => '+instanceId);
	 return new this.RSVP.Promise(function( resolve, reject ){
		 // todo add data validation
		 if( isNaN(instanceId) ){
			 reject( 'Invalid course instance id' );
		 }

		 $.ajax({
				 method: 'POST',
				 url: urls.ajax,
				 data: {
					 action: 'fetch_course_instance_details',
					 templateId: self.templateId,
					 instanceId: instanceId
				 }
			 })
			 .done(function( res ) {
				 if( res ){
					 resolve( res );
				 }
				 reject( 'An error occurred while fetching course instance details' );
			 });
	 });
};

CourseDetails.prototype.normalizeSectionsArray = function(sections){
	if(typeof sections === 'string'){
		sections = [sections];
	}
	else if(Array.isArray(sections) && sections.length === 1 && sections[0] === 'all'){
		sections = ['notes', 'past', 'current', 'future'];
	}
	
	return sections;
};

// Check if the specified course details sections array is valid
CourseDetails.prototype.isSectionsArrayValid = function(sections){
	if(Array.isArray(sections) && sections.length === 1 && sections[0] === 'all'){
		return true;
	}
	else if(Array.isArray(sections) && sections.length > 0){
		for(var i = 0; i < sections.length; i++){
			// Must be a string
			if(typeof sections[i] !== 'string'){
				return false;
			}
			// If there are multiple sections, none of them can be 'all'
			else if(sections[i] === 'all'){
				return false;
			}
			// Must be in the list of valid sections
			else if(this.validSections.indexOf(sections[i]) === -1){
				return false;
			}
		}
		return true;
	}
	else{
		return false;
	}
};

// Gets all course details sections
CourseDetails.prototype.getAllSections = function(){
	this.getSections(['notes', 'past', 'current', 'future']);
};

// Gets specific course details sections
CourseDetails.prototype.getSections = function(sections){
	var self = this;
	var sectionsArray = this.normalizeSectionsArray(sections);
	var result = this.requestSections(sectionsArray);
	
	result.then(function(sectionsMarkup){
		self.initSectionsFrontEnd(sectionsMarkup, sectionsArray);
	}).catch(function(err){
		self.handleError(err);
	});
};

 // Get details for a specific course instance
CourseDetails.prototype.getInstanceDetails = function(instanceId){
	var self = this;
	var courseInstanceId = parseInt(instanceId);

	if ( !isNaN(courseInstanceId)) {
		var result = this.requestInstanceDetails(courseInstanceId);

		result.then(function(courseInstanceMarkup) {
			self.initCourseInstanceFrontEnd(courseInstanceMarkup, courseInstanceId);
		}).catch(function(err){
			self.handleError(err);
		});
	}
};

/*
 * ONE LOADER TO RULE THEM ALL,
 * ONE LOADER TO FIND THEM;
 * ONE LOADER TO LOAD YOUR DATA,
 * AND TO THE CORRECT DOM ELEMENT BIND THEM
 * 
 * Loads all specified course details sections using individual Promises, displays rotating
 * loading messages in the specified loader element, and creates an additional Promise 
 * which hides the loader once all section Promises have resolved.
 */
CourseDetails.prototype.oneLoaderToRuleThemAll = function(sections, loaderSelector){
	// Setup
	var self = this;
	var sectionsArray = this.normalizeSectionsArray(sections);
	$(loaderSelector).addClass('loading');
	var loaderMessagesInterval = this.startLoadingMessageInterval(4500, loaderSelector);
	
	// Create a promise for each section which will be resolved individually as data is fetched from method
	// Store all the resulting promises in an array
	var promises = sectionsArray.map(function(section){
		var requestSection = [section];
		var promise = self.requestSections(requestSection);
		promise.then(function(sectionsMarkup){
			self.initSectionsFrontEnd(sectionsMarkup, requestSection);
		}).catch(function(err){
			self.handleError(err);
		});
		return promise;
	});
	
	// Create one more promise which will be resolved once all the individual section promises
	// have been settled (i.e. resolved or rejected). Hide the mega-loader once complete.
	this.RSVP.allSettled(promises).then(function(results){
		//console.log('oneLoaderToRuleThemAll promise resolved with the following states and errors/values', results);
		$(loaderSelector).removeClass('loading').fadeOut();
		window.clearInterval(loaderMessagesInterval);
	}).catch(function(err){
		//console.log('oneLoaderToRuleThemAll promise rejected with the following error', err);
		$(loaderSelector).removeClass('loading').fadeOut();
		window.clearInterval(loaderMessagesInterval);
	});
};

CourseDetails.prototype.startLoadingMessageInterval = function(interval, loaderSelector){
	return window.setInterval(function(){
		var messages = $(loaderSelector + ' p.loading-message');
		var messageCount = messages.length;
		var firstElement = messages.first();
		var activeElement = messages.filter('.show');
		if( messageCount > 1 ){
			// Special case for the first run, display the first element
			var nextElement = ( activeElement.next().length ? activeElement.next() : firstElement );
			activeElement.fadeOut(function(){
				$(this).removeClass('show');
				nextElement.fadeIn(function(){
					$(this).addClass('show');
				});
			});
		}
	}, interval);
};

CourseDetails.prototype.initSectionsFrontEnd = function(sectionsMarkup, requestedSections){
	//console.log('Initializing course details sections', requestedSections);
	var self = this;
	
	for(var i = 0; i < requestedSections.length; i++){
		var sectionName = requestedSections[i];
		var sectionMarkup = '';
		if( this.sectionMappings[sectionName] ){
			var id = this.sectionMappings[sectionName].id;
			if( sectionsMarkup[sectionName] ){
				sectionMarkup += sectionsMarkup[sectionName];
			}
			$('#'+id).fadeOut(function(){
				$(this).removeClass('loading').html(sectionMarkup).fadeIn(function(){
					// Init JS events
					self.initSectionEventHandlers(this, sectionName);
				});
			});
		}
	}
};

CourseDetails.prototype.initCourseInstanceFrontEnd = function(courseInstanceMarkup, requestedInstance){
		
	var self = this;
	$('dd.future-course-block').each(function(){
		if ($(this).data('instance-id') === requestedInstance ) {
			$(this).html(courseInstanceMarkup.markup);
			// Init JS events
			initCourseEventHandlers($(this));
		}
	});

};

CourseDetails.prototype.initSectionEventHandlers = function(sectionContain, sectionName){
	var $sectionContain = $(sectionContain);
	$sectionContain.find('.accordion').accordion();
	this.initFutureSectionTabEventHandlers($sectionContain, sectionName);
	// Function defined in courses.js
	initCourseEventHandlers($sectionContain);
};

CourseDetails.prototype.initFutureSectionTabEventHandlers = function(sectionContain, sectionName){
	var self = this;
	if (sectionName === 'future') {
		sectionContain.find('dt a').each(function(){
			$(this).on('click', function(e){
				e.preventDefault();
				var $instanceId = $(this).data('instance-id');
				self.getInstanceDetails($instanceId);
				$(this).removeData('instance-id').removeAttr('data-instance-id');
			}).on('fetchInstanceDetails', function(){
				//console.log("Executing fetchInstanceDetails event");
				var $instanceId = $(this).data('instance-id');
				self.getInstanceDetails($instanceId);
				$(this).removeData('instance-id').removeAttr('data-instance-id');
			});
		});

		sectionContain.find('dt.active').each(function(){
			$(this).find('a').each(function(){
				//console.log('Triggering fetchInstanceDetails event');
				$(this).trigger('fetchInstanceDetails');
			});
		});
	}
};
 
CourseDetails.prototype.handleError = function(err, requestedSections){
	//console.log('Error loading course details sections', err);
	
	var sectionErrorMarkup = '<em>An error occurred: ' + err + '</em>';
	for(var i = 0; i < requestedSections.length; i++){
		var sectionName = requestedSections[i];
		if( this.sectionMappings[sectionName] ){
			var id = this.sectionMappings[sectionName].id;
			$('#'+id).removeClass('loading').html(sectionErrorMarkup);
		}
	}
};